// extracted by mini-css-extract-plugin
module.exports = {"stepbar":"stepbar-3v7Qj","header":"header-5lNyP","price__wrapper":"price__wrapper-1fkXM","price":"price-dobCE","price_title":"price_title-3UF-d","expand":"expand-1c7VK"};